<template>

  <!-- 弹出向导层 start-->
  <div id="pop" class="pop" v-show="pop_show">
    <span class="pop_bg" @click="closeshow()"></span>

    <div id="pop_bodyup" class="pop_content">
      <!-- 动态查询区生成 -->
      <div class="pop_head_close">
        <a class="close" href="javascript:void(0);" @click="closeshow()"></a>
      </div>
      <div>
        <h5>诉讼案例编号:{{title}}&nbsp;&nbsp;<span class="red">操作说明:直接填写步骤即可。</span> </h5>
      </div>

      <div class="content_edit">
        <div class="content_edit_item">
          <button class="pre_btn_ok" @click="refresh_data()">
            刷新
          </button>
          <button class="pre_btn_ok" @click="fun_upd('_add')" v-show="show_btn">
            保存
          </button>
          <button class="pre_btn_ok btn_del" @click="fun_upd('_del')" v-show="show_btn">
            删除
          </button>
        </div>
      </div>
      <div class="content_edit">
        <div  v-for="(r,d) in max_row" :key="d">
          <div class="content_edit_item" v-if="item.x == r.row" v-for="(item,index) in parm" :key="index">
            <component :is="NextTickName(item.type)" :inData="checkJson(item)" @com-event="refresh_view_edit">
            </component>
          </div>
        </div>
      </div>
      <table class="dataintable mark_tab">
        <tr class="tab_header">
          <td>ID</td>
          <td>序号</td>
          <td>业务编号</td>
          <td>原告</td>
          <td>被告</td>
          <td>费用名称</td>
          <td>支付金额</td>
          <td>支付日期</td>
          <td>支付方式</td>
          <td>经办人</td>
          <td>备注</td>
          <td>修改人</td>
          <td>更新时间</td>
          <td class="short0 cen">编辑</td>
        </tr>
        <tr :id="'pop_m_'+item.row_num" v-for="(item,index) in list_question" :key="index"
          @click="sel_row(item,'edit')">
          <td>{{item.id}}</td>
          <td>{{item.row_num}}</td>
          <td>{{item.sheet_no}}</td>
          <td>{{item.one_name}}</td>
          <td>{{item.two_name}}</td>
          <!-- <td><input type="number" v-model="item.sys_val" @keyup.enter="sel_row(item,'upd')" /></td> -->
          <td>{{item.q_name}}</td>
          <td>{{item.q_amount}}</td>
          <td>{{item.q_date}}</td>
          <td>{{item.q_way}}</td>
          <td>{{item.s_user}}</td>
          <td>{{item.note}}</td>
          <td>{{item.u_name}}</td>
          <td>{{item.sys_date}}</td>
          <td class="short0 cen">
            <button @click="sel_row(item,'del')">删除</button>
          </td>
        </tr>
      </table>


    </div>
  </div>
  <!-- 弹出向导层 end-->


</template>

<script>
  /*
名称：等级划分
日期：2022-03-19
作者：hj
目标：
方法 传入参数，
1、查询标识
2、编辑标识
*/

  import api from '@/utils/type.js';
  import {
    Sel_page_and_length,
    Method_Common
  } from '@/utils/loadhttpdata.js';


  export default {
    name: "pre_mark_tan",
    components: {
      "pre-table": () => import("../auto/auto_view_table.vue"),
    },
    data() {
      return {
        element_loading: false,
        pop_show: false,
        show_btn: true,
        load_url: '',
        load_json: '',
        upd_json: '',
        screenWidth: '',
        screenHeight: '',

        title: '未设置标题',
        sheet_no: '',
        sel_action: '',
        upd_action: '',
        row_id: '',
        sel_item: [], //备份点击项目
        sys_date: '',

        parm: [], //参数结构
        parm_th: [], //标题
        kw1: '',
        kw2: '',
        kw3: '',

        set_val: '',
        set_num: '',

        max_row: [],

        list_question: '',
        sys_val: 0,
        note: '',

        // post_select: ''

      };
    },
    methods: {
      NextTickName: function(key) {
        // console.log('key=' + key);
        return 'pre' + key;
      },
      checkJson: function(d) {
        let temp = '';
        temp = JSON.stringify(d)
        return temp;
      },
      refresh_view_edit: function(d, type) {
        // console.log(d);
        for (let i = 0; i < this.parm.length; i++) {
          if (this.parm[i].key == d.key) {
            if (this.parm[i].type == 'select' || this.parm[i].type == 'radio') {
              this.parm[i].val = d.val;
              this.parm[i].sel_name = d.sel_name;
              break;
            } else {
              this.parm[i].val = d.val;
              break;
            }
          }
        }

        if (type == 'save') {
          this.fun_upd('_add');
        }
      },
      showpop: function(parm) {
        this.pop_show = true;
        var Hg = $(document).height();
        // 设置背景高度
        $(".pop_bg").height(Hg);
        // 设置展示动画 第一次有慢入动作,第二次没有:原因是当前页面被缓存，除非重开
        $(".pop_bg").fadeIn("3000");
        $(".pop_content").fadeIn("3000");
        this.load_data(parm)
      },
      closeshow: function() {
        this.pop_show = false;
        $(".pop_bg").fadeOut("3000");
        $(".pop_content").fadeOut("3000");
        this.screenHeight = 0;
        this.screenWidth = 0;
      },
      // refresh_select: function(val) {
      // 	console.log(val);
      // },
      load_data: function(res) {
        this.max_row = [];
        for (let i = 1; i < 3; i++) {
          let o = {};
          o.row = i;
          this.max_row.push(o);
        }

        // 清理缓存
        this.row_id = '';
        this.sel_action = '';
        this.upd_action = '';

        for (let j = 0; j < this.parm.length; j++) {
          if (this.parm[j].type == 'select') {
            this.parm[j].val = '';
            this.parm[j].sel_name = '';
            this.parm[j].sel_val = {};
          } else {
            this.parm[j].val = '';
          }
        }

        // console.log(this.pre_data);
        let r = JSON.parse(res);
        console.log(r);

        this.title = r.title;
        this.sheet_no = r.sheet_no;

        this.sel_action = r.sel_action;
        this.upd_action = r.upd_action;

        this.parm = r.parm;
        this.parm_th = r.parm_th;
        // console.log(this.parm_th);
        // console.log(this.parm);


        if (r.sheet_flag == '已提交') {
          this.show_btn = false;
        } else {
          this.show_btn = true;
        }

        this.refresh_data();

      },
      refresh_data: function() {
        // console.log('刷新sheet_no='+this.sheet_no);

        this.element_loading = true;
        this.list_question = [];

        let r = (Math.random() + '').substring(0, 8);

        this.$post(
          api.http_method, Sel_page_and_length(this.sel_action, 1, 100, this.sheet_no, '', r)
        ).then(res => {
          this.element_loading = false;
          res = JSON.parse(res);
          if (res.length > 0) {
            let t = res[0];
            for (let i = 0; i < t.length; i++) {
              t[i].row_num = i + 1;
              this.list_question.push(t[i]);
            }

          }
        });
        // this.change_style();
      },
      sel_row: function(item, type) {
        console.log(item, 'type=' + type);
        // console.log(this.parm);
        // 判断 obj.hasOwnProperty("key")
        //2、遍历Json串获取其属性
        this.row_id = item.id;
        this.sys_date = item.sys_date;


        switch (type) {
          case 'edit': // 切换背景色
            let key = 'pop_m_';

            for (var i = 0; i < this.list_question.length; i++) {
              console.log('每行=' + this.list_question[i].row_num + ' 点击=' + item.row_num);
              if (this.list_question[i].row_num == item.row_num) {
                document.getElementById(key + item.row_num).style.background = '#92a4f3';
              } else {
                if (this.list_question[i].row_num % 2 == 0) {
                  document.getElementById(key + this.list_question[i].row_num).style.background =
                    '#fff';
                } else {
                  document.getElementById(key + this.list_question[i].row_num).style.background =
                    '#f5f5f5';
                }
              }
            }
            break;
            // case 'show': // 打开编辑页面
            // 	this.$refs.file_table.showpop();
            // 	break;
          case 'upd': // 执行保存
            this.fun_upd('_upd');
            break;
          case 'del': // 执行保存
            this.fun_upd('_del');
            break;
          default:
            break;
        }

      },
      fun_upd: function(type) {
        console.log('操作类型=' + type);
        if (type == '_upd') {
          if (this.row_id == 0) {
            this.$message({
              message: '请选择要修改的数据!',
              type: 'warning'
            });
            return;
          }
        }

        if (type == '_add') {
          let stop = false;
          let temp_name = '';
          for (let i = 0; i < this.parm.length; i++) {
            // console.log(this.parm[i]);
            if (this.parm[i].p == '1' && this.parm[i].weight == '1' && this.parm[i].val == '') {
              stop = true;
              temp_name = this.parm[i].name;
              break;
            }
          }
          if (stop) {
            this.$message({
              message: temp_name + '不能为空!',
              type: 'warning'
            });
            return;
          }
        }

        let d = [];
        d.push(this.sheet_no); //主表关键字

        for (let i = 0; i < this.parm.length; i++) {
          if (this.parm[i].p == '1') {
            d.push(this.parm[i].val);
          }
        }

        let r = (Math.random() + '').substring(0, 8);
        // console.log(d);
        let temp_data = '';
        temp_data = Method_Common('data_' + this.upd_action + type, this.row_id, this.sys_date, d, r);

        this.$post(
          api.http_method, temp_data
        ).then(res => {
          this.element_loading = false;
          res = JSON.parse(res);
          console.log(res);
          if (res.data.status == 1) {
            this.$message({
              message: res.data.msg,
              type: 'success'
            });

            this.refresh_data();

          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });
          }
        });

      }




    }
  };
</script>


<style scoped>
  .tab_header td {
    /* 纵向渐变 */
    /* Safari 5.1 - 6.0 */
    background: -webkit-linear-gradient(#3da5d9, #a2d2ff);
    /* Opera 11.1 - 12.0 */
    background: -o-linear-gradient(#3da5d9, #a2d2ff);
    /* Firefox 3.6 - 15 */
    background: -moz-linear-gradient(#3da5d9, #a2d2ff);
    /* 标准的语法（必须放在最后） */
    background: linear-gradient(#3da5d9, #a2d2ff);
    text-align: center;
    color: #000000;
    font-size: 14px;
    font-weight: 400;
  }

  .content_edit_item button {
    margin-right: 8px;
  }

  .mark_tab tr td:nth-child(1) {
    display: none;
    min-width: 48px;
    width: 48px;
    max-width: 48px;
  }

  /*  .mark_tab tr td:nth-child(3) {
	  display: none;
    min-width: 48px;
    width: 48px;
    max-width: 48px;
  	text-align: center;
  } */
</style>
